import React, { useState } from "react"
import Zoopass from "../Components/Zoopass/Zoopass"
import { useAccount } from "../Contexts/AccountContext"
import useClassesNEvents from "../Hooks/useClassesNEvents";
import EventCard from "../Components/Events/EventCard";
import DateItem from "../Components/Events/DateItem";
import ButtonCta from "../Components/ButtonCta";

export default () => {
    const { memberships, currentMembership, dictionary, buttonCtas } = useAccount();
    const { availableDates } = useClassesNEvents();
    const [openAccordion, setOpenAccordion] = useState<string | null>(null);

    const toggleAccordion = (date: string) => {
        setOpenAccordion(openAccordion === date ? null : date);
    };

    return <div className="classes-events-container">
        <ButtonCta buttonCta={buttonCtas?.get('MyAccount:ClassesNEvents:ButtonCta')}>
            {!availableDates && (
                <div className="no-events d-flex gap-2 align-items-center">
                    <span>{dictionary.get("MyAccount:ClassNEvents:Loading") ?? 'Loading...'}</span>
                    
                    <div className="spinner-grow spinner-grow-sm" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}
            {(availableDates && availableDates.length === 0) && (
                <div className="no-events">
                    <p>{dictionary.get("MyAccount:ClassNEvents:NotFoundDescription") ?? 'No upcoming classes or events found.'}</p>
                </div>
            )}
        </ButtonCta>
        
        {availableDates && availableDates.length > 0 && (
            <div className="accordion">
                {availableDates.map((dateItem, index) => (
                    <DateItem 
                        key={index}
                        dateItem={dateItem}
                        index={index}
                        openAccordion={openAccordion}
                        toggleAccordion={toggleAccordion}
                    />
                ))}
            </div>
        ) }
    </div>
}